import { Map, LngLatLike, AddLayerObject, Point } from "maplibre-gl";
import { inject, Ref } from 'vue';

/**
 * 
 * @returns the map instance from the app. Since we return .value here, the injected map will not be reactive, so we
 * should always use it in places where the map has already been injected.
 */
export function injectMap() {
	return inject<Ref<Map>>("$map")!.value
}

export function addLayer(map: Map, layer: AddLayerObject, belowTextLayers = true, belowLayer = "") {

	//remove old layer for hot reloading to work
	const oldLayer = map.getLayer(layer.id);
	const oldSource = map.getSource(layer.id);
	if (import.meta.hot) {
		if (oldLayer)
			map.removeLayer(layer.id);
		if (oldSource)
			map.removeSource(layer.id);
	}



	if (belowTextLayers) {

		const layers = map.getStyle().layers;
		// Find the index of the first symbol layer in the map style
		let firstSymbolId;
		for (let i = layers.length - 2; i >= 0; i--) {
			if (layers[i].type != 'symbol') {
				firstSymbolId = layers[i + 1].id;
				break;
			}
		}

		map.addLayer(layer, firstSymbolId);
	} else if (belowLayer) {
		map.addLayer(layer, belowLayer);
	} else {
		map.addLayer(layer);
	}
}

export function removeLayersAndSources(map: Map, layerIds: string[]) {
	for (const layerId of layerIds) {
		removeLayer(map, layerId);
		removeSource(map, layerId);
	}
}

export function removeLayer(map: Map, layerId: string) {
	if (!map || map["_removed"])
		return;
	if (map.getLayer(layerId))
		map.removeLayer(layerId);
}

export function removeSource(map: Map, sourceId: string) {
	if (!map || map["_removed"])
		return;
	if (map.getSource(sourceId))
		map.removeSource(sourceId);
}

export function pixelDistance(pos1: LngLatLike, pos2: LngLatLike, map: Map): number {
	const px1 = map.project(pos1);
	const px2 = map.project(pos2);
	return px1.dist(px2);
}

export function coordsEqual(a: number[], b: number[]): boolean {
	if (!a || !b)
		return false;
	return a[0] == b[0] && a[1] == b[1];
}

export function isNullCoords(c): boolean {
	return c[0] == 0 && c[1] == 0;
}